import React from 'react';
import { motion } from 'framer-motion';
import { CompassIcon, MessageSquareIcon, TrendingUpIcon, ActivityIcon, FingerprintIcon, UsersIcon } from 'lucide-react';
const today = [{
  label: 'Gut instinct',
  icon: CompassIcon
}, {
  label: 'Comment threads',
  icon: MessageSquareIcon
}, {
  label: 'Copying what works',
  icon: TrendingUpIcon
}];
const withPulsewave = [{
  label: 'Audience intelligence',
  icon: ActivityIcon
}, {
  label: 'Creator-specific ideas',
  icon: FingerprintIcon
}, {
  label: 'Fan-backed direction',
  icon: UsersIcon
}];
export function Stakes() {
  return <section className="py-24 px-6 relative border-t border-white/5 bg-navy-950" data-id="element-157">
      <div className="max-w-5xl mx-auto" data-id="element-158">
        <div className="text-center mb-14" data-id="element-159">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-semibold tracking-tight mb-4" data-id="element-160">
            From scattered insights to creative clarity.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-161">
            You built the brand and the audience. Use Pulsewave to curate
            critical insights and supercharge your next idea.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-14" data-id="element-162">
          {/* Today */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-navy-900/50 border border-white/5 rounded-3xl p-7" data-id="element-163">
            <div className="text-sm font-medium text-slate-500 mb-5 uppercase tracking-wider" data-id="element-164">
              Today
            </div>
            <div className="space-y-3" data-id="element-165">
              {today.map((item, i) => {
              const Icon = item.icon;
              return <div key={i} className="flex items-center gap-3 bg-navy-950/60 border border-white/5 rounded-2xl px-4 py-3.5" data-id="element-166">
                    <div className="w-9 h-9 rounded-xl bg-navy-800 flex items-center justify-center shrink-0" data-id="element-167">
                      <Icon className="w-4.5 h-4.5 text-slate-400" data-id="element-168" />
                    </div>
                    <span className="text-sm font-medium text-slate-300" data-id="element-169">
                      {item.label}
                    </span>
                  </div>;
            })}
            </div>
            <p className="text-xs text-slate-500 mt-5" data-id="element-170">
              Useful signals, but scattered and incomplete.
            </p>
          </motion.div>

          {/* With Pulsewave */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.15
        }} className="bg-gradient-to-b from-navy-800 to-navy-900 border border-electric/20 rounded-3xl p-7 box-glow" data-id="element-171">
            <div className="text-sm font-medium text-electric mb-5 uppercase tracking-wider" data-id="element-172">
              With Pulsewave
            </div>
            <div className="space-y-3" data-id="element-173">
              {withPulsewave.map((item, i) => {
              const Icon = item.icon;
              return <div key={i} className="flex items-center gap-3 bg-navy-950/40 border border-electric/10 rounded-2xl px-4 py-3.5" data-id="element-174">
                    <div className="w-9 h-9 rounded-xl bg-electric/10 flex items-center justify-center shrink-0" data-id="element-175">
                      <Icon className="w-4.5 h-4.5 text-electric" data-id="element-176" />
                    </div>
                    <span className="text-sm font-medium text-white" data-id="element-177">
                      {item.label}
                    </span>
                  </div>;
            })}
            </div>
            <p className="text-xs text-slate-400 mt-5" data-id="element-178">
              A clearer path to what your fans are ready for.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-179">
          <p className="text-xl md:text-2xl font-medium text-white max-w-3xl mx-auto leading-relaxed" data-id="element-180">
            Unlock new opportunities.
          </p>
        </motion.div>
      </div>
    </section>;
}